import { config } from '../config/config';
import windows10ProImg from '../assets/images/windows_10_pro.png';
import windows11ProImg from '../assets/images/windows_11_pro.png';
import windowsServer2025Img from '../assets/images/windows_server_2025.png';
import msOffice2021ProImg from '../assets/images/ms_office_2021_pro.png';
import msOffice2024ProImg from '../assets/images/ms_office_2024_pro.png';
import msOffice2024HbImg from '../assets/images/ms_office_2024_hb.png';
import categoryWindowsImg from '../assets/images/category_windows.jpg';
import categoryMsOfficeImg from '../assets/images/category_msoffice.jpg';
import categoryServerImg from '../assets/images/category_server.jpg';
import categoryAdobeImg from '../assets/images/category_adobe.jpg';
import categoryOthersImg from '../assets/images/category_others.jpg';
import categoryComboImg from '../assets/images/category_combo.jpg';

const assetMap = {
  'windows_10_pro.png': windows10ProImg,
  'windows_11_pro.png': windows11ProImg,
  'windows_server_2025.png': windowsServer2025Img,
  'ms_office_2021_pro.png': msOffice2021ProImg,
  'ms_office_2024_pro.png': msOffice2024ProImg,
  'ms_office_2024_hb.png': msOffice2024HbImg,
  'category_windows.jpg': categoryWindowsImg,
  'category_msoffice.jpg': categoryMsOfficeImg,
  'category_server.jpg': categoryServerImg,
  'category_adobe.jpg': categoryAdobeImg,
  'category_others.jpg': categoryOthersImg,
  'category_combo.jpg': categoryComboImg,
};

export const getProductImage = (image, defaultFallback = windows10ProImg) => {
  if (!image) return defaultFallback;

  // If already an imported module object or ES module
  if (typeof image === 'object') {
    if (image.default) return image.default;
    if (image.src) return image.src;
  }

  if (typeof image !== 'string') return defaultFallback;

  // Trim whitespace
  const trimmed = image.trim();
  if (!trimmed) return defaultFallback;

  // Data URLs, Blob URLs
  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed;
  }

  // Full absolute URLs (HTTP / HTTPS)
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }

  // Webpack bundled CRA media files (e.g. /static/media/...)
  if (trimmed.startsWith('/static/')) {
    return trimmed;
  }

  // Public asset paths
  if (trimmed.startsWith('/assets/') || trimmed.startsWith('assets/')) {
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  }

  // Lookup in static assetMap
  const filename = trimmed.split('/').pop().split('\\').pop();
  if (assetMap[filename]) {
    return assetMap[filename];
  }
  if (assetMap[trimmed]) {
    return assetMap[trimmed];
  }

  // If starts with / and not static, prepend API URL
  if (trimmed.startsWith('/')) {
    return `${config.apiUrl}${trimmed}`;
  }

  // Otherwise assume backend uploads path
  return `${config.apiUrl}/uploads/products/${trimmed}`;
};
